export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Comanda ta a fost văzută',
    order_confirmed: '#{{number}} Confirmat ora {{time}}',
    order_preparation_up_time_changed: '#{{number}} Timp de {{type}} modificat la {{time}}',
    serving_time_changed: '#{{number}} Comanda ta va fi servită la {{time}}',
    order_preparing: 'Comanda ta #{{number}} este în curs de pregătire',
    order_rejected: '#{{number}} comandă respinsă',
  },
  order_type: {
    pickup: 'Ridicare',
    delivery: 'Livrare',
  },
};
